<template>
  <div :style="( search == true) ? 'background-color : white':''">
    <v-select
      placeholder="Search here..."
      :label="dd_label"
      :reduce="options => options[dd_value]"
      :options="extra['data']"
      :filterable="false"
      v-model="post"
      :inputId="name"
      @input="send"
      @search="searchAutocomplete"
    >
      <template #search="{attributes, events}" v-if="required == true">
        <input class="vs__search" :required="!post" v-bind="attributes" v-on="events" />
      </template>
    </v-select>
  </div>
</template>

<script>
import { _ } from "vue-underscore";

export default {
  props: [
    "name",
    "validation",
    "content",
    "options",
    "dropdown_name",
    "parsingPost",
    "parsingPostMulti",
    "parsingTrigger",
    "table_module",
    "search",
    "extraSearch",
  ],
  data() {
    return {
      post: "",
      extra: [],
      dd_label: "",
      dd_value: "",
    };
  },
  watch: {
    parsingTrigger(newValue) {
      if (this.name == "crs_model_id") {
        if (newValue.crs_model_id != "") {
          this.post = "";
          this.extra = [];
        }
      }
    },
    extraSearch(newValue) {
      if (this.search == true) {
        this.extra["data"] = newValue;
      }
    },
    content() {
      if (this.dropdown_name == "crs_brand_id") {
      this.dd_label = "crs_brand_name";
      this.dd_value = "crs_brand_id";
    } else if (this.dropdown_name == "crs_model_id") {
      this.dd_label = "crs_model_name";
      this.dd_value = "crs_model_id";
      if (this.table_module == "services_bulk") {
        var value = "";
        if (this.content != "undefined" && this.content != null) {
          if (typeof this.content["crs_model_id"] !== undefined) {
            value = this.content["crs_model_id"];
          }
        }
        this.$emit("post", {
          name: this.name,
          value: value,
        });
      }
    } else if (this.dropdown_name == "brd_id") {
      this.dd_label = "brd_name";
      this.dd_value = "brd_id";
    } else if (this.dropdown_name == "div_id") {
      this.dd_label = "div_name";
      this.dd_value = "div_id";
    } else if (this.dropdown_name == "emp_id") {
      this.dd_label = "emp_name";
      this.dd_value = "emp_id";
    } else if (this.dropdown_name == "prd_c_id") {
      this.dd_label = "prd_c_name";
      this.dd_value = "prd_c_id";
    } else if (this.dropdown_name == "cst_id") {
      this.dd_label = "usr_fullname";
      this.dd_value = "usr_id";
    }

    if (this.content != "" && this.content != undefined) {
      this.post = this.content;
      var arx = [
        {
          [this.dd_label]: this.content[this.dd_label],
          [this.dd_value]: this.content[this.dd_value],
        },
      ];

      if (this.search == true) {
        this.extra["data"] = this.extraSearch;
      } else {
        this.extra["data"] = arx;
      }
    }
    }
  },
  mounted() {
    if (this.dropdown_name == "crs_brand_id") {
      this.dd_label = "crs_brand_name";
      this.dd_value = "crs_brand_id";
    } else if (this.dropdown_name == "crs_model_id") {
      this.dd_label = "crs_model_name";
      this.dd_value = "crs_model_id";
      if (this.table_module == "services_bulk") {
        var value = "";
        if (this.content != "undefined" && this.content != null) {
          if (typeof this.content["crs_model_id"] !== undefined) {
            value = this.content["crs_model_id"];
          }
        }
        this.$emit("post", {
          name: this.name,
          value: value,
        });
      }
    } else if (this.dropdown_name == "brd_id") {
      this.dd_label = "brd_name";
      this.dd_value = "brd_id";
    } else if (this.dropdown_name == "div_id") {
      this.dd_label = "div_name";
      this.dd_value = "div_id";
    } else if (this.dropdown_name == "emp_id") {
      this.dd_label = "emp_name";
      this.dd_value = "emp_id";
    } else if (this.dropdown_name == "prd_c_id") {
      this.dd_label = "prd_c_name";
      this.dd_value = "prd_c_id";
    } else if (this.dropdown_name == "cst_id") {
      this.dd_label = "usr_fullname";
      this.dd_value = "usr_id";
    }

    if (this.content != "" && this.content != undefined) {
      this.post = this.content;
      var arx = [
        {
          [this.dd_label]: this.content[this.dd_label],
          [this.dd_value]: this.content[this.dd_value],
        },
      ];

      if (this.search == true) {
        this.extra["data"] = this.extraSearch;
      } else {
        this.extra["data"] = arx;
      }
    }
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    },
    valueCrsBrand() {
      var res = "";
      if (typeof this.parsingPost != "undefined") {
        if (
          this.parsingPost.crs_brand_id != "" &&
          this.parsingPost.crs_brand_id != undefined
        ) {
          res = this.parsingPost.crs_brand_id;
        }
      } else if (typeof this.parsingPostMulti != "undefined") {
        if (
          this.parsingPostMulti.crs_brand_id != "" &&
          this.parsingPostMulti.crs_brand_id != undefined
        ) {
          res = this.parsingPostMulti.crs_brand_id;
        }
      }
      return res;
    },
  },
  methods: {
    send() {
      if (this.table_module == "services_bulk") {
        this.$emit("post", {
          name: "srv_id",
          value: null,
        });
      }

      if (this.search == true) {
        let find = this.extra["data"].findIndex(
          (r) => r[this.dd_value] == this.post
        );

        if (find >= 0) {
          this.$emit("post", {
            name: this.name,
            value: this.post,
            content: [
              {
                [this.dd_label]: this.extra["data"][find][this.dd_label],
                [this.dd_value]: this.post,
              },
            ],
            type: "single_autocomplete",
          });
        }
      } else {
        if (this.table_module == "services_transaction") {
          if (this.dropdown_name == 'emp_id') {
            let find = this.extra["data"].findIndex(
              (r) => r["emp_id"] == this.post
            );

            if (find != -1) {
              this.$emit("post", {
                name: this.name,
                value: this.extra["data"][find],
              });            
              
            }

          }
        } else {
          this.$emit("post", {
            name: this.name,
            value: this.post,
          });
        }
      }
    },
    searchAutocomplete(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.searchDeb(loading, search, this);
      }
    },
    searchDeb: _.debounce((loading, search, vm) => {
      var params = {};

      if (vm.dropdown_name == "crs_brand_id") {
        vm.dd_label = "crs_brand_name";
        vm.dd_value = "crs_brand_id";

        params = {
          ["search[crs_brand_name]"]: search,
        };
      } else if (vm.dropdown_name == "crs_model_id") {
        vm.dd_label = "crs_model_name";
        vm.dd_value = "crs_model_id";

        params = {
          ["search[crs_model_name]"]: search,
        };
      } else if (vm.dropdown_name == "brd_id") {
        vm.dd_label = "brd_name";
        vm.dd_value = "brd_id";

        params = {
          ["search[brd_name]"]: search,
        };
      } else if (vm.dropdown_name == "div_id") {
        vm.dd_label = "div_name";
        vm.dd_value = "div_id";

        params = {
          ["search[div_name]"]: search,
        };
      } else if (vm.dropdown_name == "prd_c_id") {
        vm.dd_label = "prd_c_name";
        vm.dd_value = "prd_c_id";

        params = {
          ["search[prd_c_name]"]: search,
        };
      } else if (vm.dropdown_name == "cst_id") {
        vm.dd_label = "usr_fullname";
        vm.dd_value = "usr_id";

        params = {
          ["search[usr_fullname]"]: search,
        };
      } else if (vm.dropdown_name == "emp_id") {
        vm.dd_label = "emp_name";
        vm.dd_value = "emp_id";

        params = {
          ["search[emp_name]"]: search,
        };
      }

      if (vm.name == "crs_model_id") {
        if (vm.valueCrsBrand != "") {
          params["filter[crs_brand_id]"] = vm.valueCrsBrand;
        }
      }

      vm.axios
        .get("/dropdown/autocomplete/" + vm.dropdown_name, { params: params })
        .then((response) => {
          loading(false);
          vm.extra = response.data.data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 500),
  },
};
</script>